export const defaultStyle = {
  navContainer:
    "navContainer relative flex flex-wrap space-between items-center  transition delay-150 duration-500 ease-in-out before:text-[11px]",
  searchboxStyles: {
    formContainer: `flex justify-between content-center z-[9999] overflow-hidden searchInput print-noshow absolute right-0 bg-white rounded-20 border-2 px-8 border-borderGrey py-[0.1rem] mr-[30px] cursor-pointer items-center`,
    form: "ml-[7px] w-full",
    image: "z-[9] lg:h-15 mt-[-7px]",
    input:
      "outline-none bg-transparent text-15 placeholder-darkBlue max-w-full z-5 placeholder-opacity-[0.5]",
  },
  stockTicker: "text-black font-bold font-calib text-[15px] tracking-[1.8px] w-[33.33%] pr-[15px]",
  searchToggle:"px-[15px]"

}





